import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4a9f7511"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../tools/node_modules/.pnpm/vue-loader@15.11.1_oyhijetsnqchcaumwhvttdg63u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports